/* RESPONSIBLE TEAM: team-data-foundations */
import GlobalLoadingRoute from 'embercom/routes/base/global-loading-route';

let CompaniesLoadingRoute = GlobalLoadingRoute.extend({});

export default CompaniesLoadingRoute;
